import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
import { useState } from "react";
import Toaster from "../../components/Toaster";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import { AddProductColorAttribute, resetStatus } from "@/store/slices/productSlice";
import ShowLoader from "@/components/Loader";

const schema = yup.object().shape({
  value: yup.string().required("Code is required"),
  code: yup
    .string()
    .required("Color value is required")
    .matches(/^#([0-9A-F]{6}|[0-9A-F]{3})$/i, "Invalid hex color code"),
});

export function AddProductColor({ open, handler, colorAttributeAdded }) {

    const dispatch = useDispatch();
    
    const { loading } = useSelector((state) => state.product);
    
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
    resolver: yupResolver(schema),
    });

    const close = () => {
        reset();
        handler();
    }
    const onSubmit = async (data) => {
        try {
            const result = await dispatch(AddProductColorAttribute(data)).unwrap();
            if (result.status) {
                Toaster.success('Product color added successfully!');
                dispatch(resetStatus());
                colorAttributeAdded();
                close();
            } else {
                Toaster.error(result.message || "Something went wrong!");
                dispatch(resetStatus());
            }
        } catch (err) {
            Toaster.error(err?.message || "Failed to add product");
            dispatch(resetStatus());
        }
    }

    return (
    <Dialog open={open} handler={close}>
      {loading && <ShowLoader /> }
      <DialogHeader>Add Product Color</DialogHeader>
      <form className="p-6" onSubmit={handleSubmit(onSubmit)}>
        <DialogBody>
            <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Pick a Color <span className="text-red-500">*</span>
                </label>
                <div className="flex items-center gap-3">
                    <input
                    type="color"
                    className="w-full h-12 rounded-lg cursor-pointer border shadow-sm"
                    {...register('code')}
                    />
                </div>
                {errors.code && (
                    <p className="text-red-500 text-sm mt-1">{errors.code.message}</p>
                )}
            </div>
            <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Color Name <span className="text-red-500">*</span>
                </label>
                <input
                type="text"
                placeholder="Enter color name"
                className="border rounded-lg p-2 w-full mt-4"
                {...register('value')}
                />
                {errors.value && (
                    <p className="text-red-500 text-sm mt-1">{errors.value.message}</p>
                )}
            </div>
        </DialogBody>
        <DialogFooter>
            <Button
            variant="text"
            color="red"
            onClick={close}
            className="mr-1"
            >
            <span>Cancel</span>
            </Button>
            <Button variant="gradient" color="green" type="submit">
            <span>Confirm</span>
            </Button>
        </DialogFooter>
      </form>
    </Dialog>
  );
}

export default AddProductColor;
